import { render, staticRenderFns } from "./RedimensionamentoHospitalarAgiDownload.vue?vue&type=template&id=ae050630&scoped=true"
import script from "./RedimensionamentoHospitalarAgiDownload.vue?vue&type=script&lang=js"
export * from "./RedimensionamentoHospitalarAgiDownload.vue?vue&type=script&lang=js"
import style0 from "./RedimensionamentoHospitalarAgiDownload.vue?vue&type=style&index=0&id=ae050630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae050630",
  null
  
)

export default component.exports